import './EventFeaturedImage.css';

function EventFeaturedImage({ src, alt, date }) {
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);
  
  return (
    <div className="event-featured-image">
      <img src={src || 'https://via.placeholder.com/1200x600?text=Evento'} alt={alt} />
      <div className="event-date-overlay">
        <div className="date-day">{dateObj.getDate()}</div>
        <div className="date-month">
          {dateObj.toLocaleDateString('it-IT', { month: 'short' })}
        </div>
        <div className="date-year">{dateObj.getFullYear()}</div>
      </div>
    </div>
  );
}

export default EventFeaturedImage;
